import { format } from 'date-fns/format';
import { startOfMonth } from 'date-fns/startOfMonth';
import { subMonths } from 'date-fns/subMonths';

/** Jour du mois à partir duquel les primes basculent sur le mois calendaire en cours. */
export const PRIME_PENDING_MONTH_ROLLOVER_DAY = 20;

/** Début du mois civil considéré « en cours » pour les primes (avant le 20 → mois précédent). */
export const getPrimePendingMonthStart = (now: Date = new Date()): Date => {
  if (now.getDate() >= PRIME_PENDING_MONTH_ROLLOVER_DAY) {
    return startOfMonth(now);
  }
  return startOfMonth(subMonths(now, 1));
};

/** Date de référence (15 du mois) pour les requêtes API primes — évite les décalages fuseau horaire. */
export const getPrimePendingReferenceDate = (now: Date = new Date()): Date => {
  const pendingMonthStart = getPrimePendingMonthStart(now);
  return new Date(pendingMonthStart.getFullYear(), pendingMonthStart.getMonth(), 15);
};

/** Libellé MM/yyyy du mois en cours pour les primes pending. */
export const getPrimePendingMonthYear = (now: Date = new Date()): string =>
  format(getPrimePendingMonthStart(now), 'MM/yyyy');
